import { RootState } from '../../store';

export const getTicketNumberSelector = (state: RootState) => state.ticketReducer.ticketNumber;
